import React, { lazy, useEffect, useState } from "react";

import RightHeader from "../../../base/right-menu/RightHeader";
import ChatBody from "../../../chat/components/web/ChatBody";
import ChatFooter from "../../../chat/components/web/ChatFooter";

function GroupChat({
    messages, participant, handlerChatFile, handlerChatMessage
}) {    
    return (
        <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column",     overflow: "hidden" }}>
            <ChatBody messages={messages} />
            {/* <ChatFooter 
                hideFile={true}
                participant={participant}
                handlerChatMessage={handlerChatMessage}
                handlerChatFile={handlerChatFile}/> */}
        </div>
    )
}

export default GroupChat;